import React, { useState } from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import {
  makeStyles,
  Collapse,
  Paper,
  Typography,
  Card,
  CardActions,
  IconButton,
  CloseIcon,
  ExpandMoreIcon,
} from '@gogame/components';

const useStyles = (variant) => {
  const stylesFn = makeStyles((theme) => {
    return {
      card: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        flexGrow: 1,
        backgroundColor: theme.palette[variant]
          ? theme.palette[variant].main
          : 'rgb(49,49,49)',
        [theme.breakpoints.up('sm')]: {
          flexGrow: 'initial',
          minWidth: 344,
        },
      },
      typography: {
        fontWeight: 'bold',
      },
      actionRoot: {
        margin: 0,
        padding: '8px 8px 8px 16px',
        color: '#fff',
      },
      icons: {
        marginLeft: 'auto!important',
      },
      expand: {
        padding: '8px 8px',
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shortest,
        }),
      },
      expandOpen: {
        transform: 'rotate(180deg)',
      },
      collapse: {
        padding: 16,
        borderRadius: 0,
      },
      textColor: {
        color: '#fff',
      },
    };
  });

  return stylesFn();
};

const SnackMessageList = React.forwardRef(
  ({ messageVariant, onCloseMessage, messages, title, id }, ref) => {
    const classes = useStyles(messageVariant);
    const [expanded, setExpanded] = useState(false);

    const handleExpandClick = () => {
      setExpanded(!expanded);
    };

    const handleClose = () => {
      onCloseMessage(id);
    };

    return (
      <Card className={classes.card} ref={ref}>
        <CardActions classes={{ root: classes.actionRoot }}>
          <Typography variant={'subtitle2'} className={classes.typography}>
            {title}
          </Typography>
          <div className={classes.icons}>
            <IconButton
              className={classnames(classes.expand, classes.textColor, {
                [classes.expandOpen]: expanded,
              })}
              tooltip={'Show/Hide Items'}
              onClick={handleExpandClick}
            >
              <ExpandMoreIcon />
            </IconButton>
            <IconButton
              className={classes.expand}
              onClick={handleClose}
              tooltip={'Close All'}
            >
              <CloseIcon className={classnames(classes.textColor)} />
            </IconButton>
          </div>
        </CardActions>
        <Collapse in={expanded} timeout={'auto'} unmountOnExit>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              maxHeight: 'calc(100vh - 56px)',
            }}
          >
            <div style={{ flexGrow: '1', overflow: 'auto' }}>
              {messages.map((text) => (
                <Paper className={classes.collapse}>
                  <Typography gutterBottom>{text}</Typography>
                </Paper>
              ))}
            </div>
          </div>
        </Collapse>
      </Card>
    );
  }
);

SnackMessageList.propTypes = {
  id: PropTypes.number.isRequired,
};

export default SnackMessageList;
